import React from 'react';

import { Box, Text } from '@mantine/core';
import { IconArrowDown, IconArrowUp } from '@tabler/icons-react';

type ChangeCellProps = {
  change: number;
};

type CellFormat = {
  color: string;
  icon: React.ReactNode;
};

const format = (change: number): CellFormat => {
  if (change > 0) {
    return { color: 'green', icon: <IconArrowUp size={16} color='green' /> };
  }

  if (change < 0) {
    return { color: 'red', icon: <IconArrowDown size={16} color='red' /> };
  }

  return { color: 'gray', icon: <></> };
};

const ChangeCell = ({ change }: ChangeCellProps): JSX.Element => {
  const formatted = format(change);

  return (
    <Box display='flex' sx={{ justifyContent: 'center' }}>
      {formatted.icon}
      <Text color={formatted.color}>{(Math.abs(change) * 100).toFixed(1)}%</Text>
    </Box>
  );
};

export default ChangeCell;
